/* eslint-disable */

export const drawer = {
  namespaced: true,
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: require('@/assets/images/background-tender-2.png'),
    drawer: null,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
  },
  actions: {
    set_bar_image({commit}, payload){
      commit('SET_BAR_IMAGE', payload)
    },
    set_drawer({commit}, payload){
      // console.log(payload)
      commit('SET_DRAWER', payload)
    },
    set_scrim({commit}, payload){
      commit('SET_SCRIM', payload)
    }
  },
  getters:{

  }

}
